import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Link } from 'react-router-dom';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import MobileCTA from './components/MobileCTA';
import StickyCTA from './components/StickyCTA';
import Home from './pages/Home';
import Packages from './pages/Packages';
import Schedule from './pages/Schedule';
import Contact from './pages/Contact';
import Book from './pages/Book';
import Admin from './pages/Admin';
import { trackPageView } from './utils/analytics';
import './index.css';

const PAYPAL_OPTIONS = {
  'client-id': process.env.REACT_APP_PAYPAL_CLIENT_ID || '',
  currency: 'USD',
  intent: 'capture',
};

function NotFound() {
  return (
    <div style={{ minHeight: '70vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '40px 20px' }}>
      <h1 style={{ fontSize: '5rem', fontWeight: 900, color: 'var(--lime)', lineHeight: 1, marginBottom: '8px' }}>404</h1>
      <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '12px' }}>Page Not Found</h2>
      <p style={{ color: 'var(--muted)', marginBottom: '32px' }}>That page doesn't exist. Let's get you back on track.</p>
      <Link to="/" className="btn btn-primary">Back to Home</Link>
    </div>
  );
}

function Layout() {
  const { pathname } = useLocation();
  const isAdmin = pathname === '/admin';

  useEffect(() => {
    if (!isAdmin) trackPageView(pathname);
  }, [pathname, isAdmin]);

  return (
    <>
      {!isAdmin && <Navbar />}
      <main>
        <Routes>
          <Route path="/"         element={<Home />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/contact"  element={<Contact />} />
          <Route path="/book"     element={<Book />} />
          <Route path="/admin"    element={<Admin />} />
          <Route path="*"         element={<NotFound />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <MobileCTA />}
      {!isAdmin && <StickyCTA />}
    </>
  );
}

export default function App() {
  return (
    <PayPalScriptProvider options={PAYPAL_OPTIONS}>
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
    </PayPalScriptProvider>
  );
}
